import logo from "LandingPage/Assets/logo.png";
import { useState, useEffect } from "react";
import styles from "./Navbar.module.scss";
import { Snackbar, Alert } from "@mui/material";
import classNames from "classnames";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [demoSnackbar, setDemoSnackbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Explore", href: "/explore", external: false },
    { label: "Public Profile", href: "https://public-profile.academic.online", external: true },
  ];

  return (
    <>
      <header
        className={classNames(styles["navbar"], {
          [styles["navbar--scrolled"]]: scrolled,
        })}
        id="main-navbar"
      >
        <div className={styles["navbar__container"]}>
          {/* Logo */}
          <a href="/" className={styles["navbar__logo-link"]}>
            <img
              src={logo}
              alt="Academic Online"
              className={styles["navbar__logo"]}
            />
          </a>

          {/* Desktop Nav */}
          <nav className={styles["navbar__nav"]} aria-label="Main navigation">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className={styles["navbar__nav-link"]}
                {...(link.external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop Auth */}
          <div className={styles["navbar__auth"]}>
            <button
              className={styles["navbar__demo-btn"]}
              onClick={(e) => {
                e.preventDefault();
                setDemoSnackbar(true);
              }}
              type="button"
            >
              Book a Demo
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            className={classNames(styles["navbar__hamburger"], {
              [styles["navbar__hamburger--open"]]: mobileMenuOpen,
            })}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle navigation menu"
            type="button"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={classNames(styles["navbar__mobile-menu"], {
            [styles["navbar__mobile-menu--open"]]: mobileMenuOpen,
          })}
        >
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={styles["navbar__mobile-link"]}
              onClick={() => setMobileMenuOpen(false)}
              {...(link.external
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
            >
              {link.label}
            </a>
          ))}
          <div className={styles["navbar__mobile-auth"]}>
            <button
              className={styles["navbar__demo-btn"]}
              onClick={(e) => {
                e.preventDefault();
                setDemoSnackbar(true);
                setMobileMenuOpen(false);
              }}
              type="button"
            >
              Book a Demo
            </button>
          </div>
        </div>
      </header>

      {/* ── Demo Coming Soon Snackbar ── */}
      <Snackbar
        open={demoSnackbar}
        autoHideDuration={3000}
        onClose={() => setDemoSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setDemoSnackbar(false)}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Coming soon! We&apos;re working on this feature.
        </Alert>
      </Snackbar>
    </>
  );
};

export default Navbar;
